/**
 * Service de transformation des données du formulaire de garantie
 * Convertit WarrantyFormState en CreateWarrantyDto pour l'API
 */

import type { CreateWarrantyDto } from '../types/warranty.types';
import type { WarrantyFormState } from '../hooks/useWarrantyFormWizard';

/**
 * Convertit les données du formulaire en DTO pour l'API
 * @param formData - Données du formulaire
 * @param canMensualize - Si la mensualisation est disponible pour cette société
 * @returns DTO prêt pour l'API
 */
export const mapWarrantyFormToDto = (
  formData: WarrantyFormState,
  canMensualize: boolean
): CreateWarrantyDto => {
  return {
    societyId: formData.societyId!,
    warrantyType: formData.warrantyType!,
    name: formData.name,
    vehicleType: formData.vehicleType!,
    duration: formData.duration!,
    sellingPrice: formData.sellingPrice!,
    // `servicePrice` n'est transmis que s'il a été explicitement saisi — ce que le
    // wizard ne permet pas. Omis, l'API le résout depuis la grille tarifaire
    // (tarif propre → parent facturant → catalogue), et l'ignore de toute façon
    // pour un utilisateur non interne. Le pré-remplir depuis le formulaire
    // produisait soit un 400 quand la résolution n'avait pas encore répondu, soit
    // le tarif d'une durée précédemment consultée.
    ...(formData.servicePrice !== undefined && formData.servicePrice !== null
      ? { servicePrice: formData.servicePrice }
      : {}),
    assistanceFormulaId: formData.assistanceFormulaId ?? null,
    financialCap: formData.financialCap!,
    kmLimit: formData.kmLimit,
    headTransferPrice: formData.headTransferPrice,
    memberTransferPrice: formData.memberTransferPrice,
    provision: formData.provision,
    commission: formData.commission,
    commissionType: formData.commissionType,
    partIds: formData.selectedPartIds,
    // Si mensualisation non disponible, forcer les valeurs par défaut
    isMensualisable: canMensualize ? formData.isMensualisable : false,
    isCashPayment: canMensualize ? formData.isCashPayment : true,
    isBroadcast: formData.isBroadcast,
    isActive: formData.isActive,
    diagnostic: formData.diagnostic,
  };
};
